import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "sidebar-menu-skeleton",
        "data-sidebar": "menu-skeleton",
        class: _normalizeClass($setup.cn('flex h-8 items-center gap-2 rounded-md px-2', $setup.props.class))
    }, [
        ($props.showIcon)
            ? (_openBlock(), _createBlock($setup["Skeleton"], {
                key: 0,
                class: "size-4 rounded-md",
                "data-sidebar": "menu-skeleton-icon"
            }))
            : _createCommentVNode("v-if", true),
        _createVNode($setup["Skeleton"], {
            class: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: _normalizeStyle({ '--skeleton-width': $setup.width })
        }, null, 8 /* PROPS */, ["style"])
    ], 2 /* CLASS */));
}
